import { defineComponent as _defineComponent } from 'vue'
import BaseDialog from "@/components/base-dialog.vue";
import { ref } from "vue";
import useHttpRequest from "@/composables/use-http-request";
import { useShowWarningMessage } from "@/composables/use-notifications";
import { useRoute } from "vue-router/composables";


export default /*#__PURE__*/_defineComponent({
  __name: 'grant-special-corse-work-submission-dialog',
  props: {
    isVisible: { type: Boolean },
    studentId: null,
    onRefresh: null,
    onClose: null
  },
  setup(__props: any) {

const props = __props as {
  isVisible: boolean;
  studentId: string;
  onRefresh: () => void;
  onClose: () => void;
}



const route = useRoute();

const submitting = ref(false);
const individualGrantedClosingTime = ref("");

const clearInputs = () => {
  individualGrantedClosingTime.value = "";
};

const onDialogClose = () => {
  props.onClose();
};

const validateInput = () => {
  if (individualGrantedClosingTime.value === "") {
    return useShowWarningMessage(
      "Closing time required",
      "Please grant closing time"
    );
  }
  return true;
};

const grantTimeChanges = async () => {
  if (validateInput() !== true) {
    return;
  }

  const request = await useHttpRequest<{ success: boolean; message: string }>({
    method: "POST",
    url: "course-work/grant-student-additional-time",
    loadingProperty: submitting,
    showSuccessMessage: true,
    body: {
      special_submission_time: individualGrantedClosingTime.value,
      course_work_id: route.params.courseWorkId,
      student_id: props.studentId,
    },
  });

  if (!request) return;
  if (
    request.success &&
    request.message == "Student Granted Special Submission"
  ) {
    clearInputs();
    props.onRefresh();
    onDialogClose();
  }
};

return { __sfc: true,props, route, submitting, individualGrantedClosingTime, clearInputs, onDialogClose, validateInput, grantTimeChanges, BaseDialog }
}

})